"use strict";

exports.__esModule = true;
exports["default"] = void 0;

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

var _themeUi = require("theme-ui");

var _useControlledState2 = _interopRequireDefault(require("../../hooks/useControlledState"));

var _ContentReveal = _interopRequireDefault(require("../ContentReveal/ContentReveal"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var Accordion = function Accordion(_ref) {
  var id = _ref.id,
      expandedExternal = _ref.expanded,
      HeaderComponent = _ref.HeaderComponent,
      children = _ref.children,
      props = _objectWithoutPropertiesLoose(_ref, ["id", "expanded", "HeaderComponent", "children"]);

  var _useControlledState = (0, _useControlledState2["default"])(expandedExternal, HeaderComponent.props ? HeaderComponent.props.onClick : null),
      expanded = _useControlledState[0],
      setExpanded = _useControlledState[1];

  var InjectedHeaderComponent;
  var forwardingProps = {
    id: id + "-button",
    contentId: id + "-content",
    expanded: expanded,
    onClick: function onClick() {
      return setExpanded(function (prevState) {
        return !prevState;
      });
    }
  };

  if (typeof HeaderComponent === 'function') {
    InjectedHeaderComponent = HeaderComponent(forwardingProps);
  } else {
    InjectedHeaderComponent = _react["default"].cloneElement(HeaderComponent, forwardingProps);
  }

  return (0, _themeUi.jsx)("div", _extends({}, props, {
    sx: {
      justifyContent: 'center'
    }
  }), InjectedHeaderComponent, (0, _themeUi.jsx)(_ContentReveal["default"], {
    visible: expanded
  }, (0, _themeUi.jsx)(_themeUi.Flex, {
    id: id + "-content",
    "aria-labelledby": id + "-button",
    role: "region",
    sx: {
      flexDirection: 'column'
    }
  }, children)));
};

Accordion.propTypes = {
  id: _propTypes["default"].string.isRequired,
  expanded: _propTypes["default"].bool,
  children: _propTypes["default"].node,
  HeaderComponent: _propTypes["default"].oneOfType([_propTypes["default"].node, _propTypes["default"].func]).isRequired
};
Accordion.defaultProps = {
  expanded: false,
  children: null
};
var _default = Accordion;
exports["default"] = _default;